import contentAPIRoutes from './content-api';

const routes = {
    'content-api': {
        type: 'content-api',
        routes: contentAPIRoutes,
    },
};

export default routes;
